module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/new-deposit/new-deposit.component.css
// module id = ./src/app/accountmaster/new-deposit/new-deposit.component.css
// module chunks = main